import { ApiRoutes } from "@/enums/apiRoutes.enum";
import axios from "@/lib/axios";
import {
  convertCouponDtoToFormData,
  convertToServerFormat,
} from "@/utils/converters";
import { ICoupon } from "@/types/data";

export const couponService = {
  async create(data: ICoupon) {
    const response = await axios.post(
      ApiRoutes.COUPONS,
      convertToServerFormat(data),
    );
    return response.data;
  },

  async update(data: ICoupon) {
    const response = await axios.put(
      ApiRoutes.COUPONS,
      convertToServerFormat(data),
    );
    return response.data;
  },

  async delete(ids: string[] | number) {
    if (Array.isArray(ids)) {
      const responses = await Promise.all(
        ids.map((id) => axios.get(`${ApiRoutes.COUPONS}/delete/${id}`)),
      );
      return responses.map((res) => res.data);
    }
    const response = await axios.get(`${ApiRoutes.COUPONS}/delete/${ids}`);
    return response.data;
  },

  async getAvailable(): Promise<ICoupon[]> {
    // includeUnavailable=true so inactive coupons show in the table, the assign dialog,
    // and analytics too (a custom-sent coupon is still worth its metrics).
    // extended=true pulls the full coupon config (type/discount/target/mystery) so the
    // edit form can pre-fill; the RN app omits it and keeps the lean default shape.
    const response = await axios.get(
      `${ApiRoutes.COUPONS_AVAILABLE}?includeUnavailable=true&extended=true`,
    );
    // v2 coupons service wraps rows as { ok, count, data }; tolerate a bare array too.
    const rows = Array.isArray(response.data)
      ? response.data
      : (response.data?.data ?? []);
    return rows.map(convertCouponDtoToFormData);
  },

  async getTop() {
    const response = await axios.get(ApiRoutes.COUPONS_TOP);
    return response.data;
  },
};
